function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgHuge = function SvgHuge(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 48,
      height: 48
    }, props), _ref)
  );
};

export default SvgHuge;